import { Row, Col, Container, Card, Button, Table, Dropdown, FormCheck, Form, Collapse, Spinner, Image, Modal } from "react-bootstrap";
import Layout from "../../components/Layout";
import { useEffect, useRef, useState } from "react";
import DrewsModal from "../../components/modal/DrewsModal";
import AlertModal from "../../components/modal/AlertModal";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useDispatch, useSelector } from "react-redux";
import { deleteSmsById, getCustomersList, getSmsList, sendSms } from "../../redux/slices/users";
import Swal from "sweetalert2";
import Select from 'react-select';
import { managerDeleteCustomerById, managerGetCustomersList, managerGetSmsList, managerSendSms } from "../../redux/slices/managers.slice";
import envelope from "../../assets/images/envelope-alt.svg"
import dateFormatter from "../../utils/dateFormatter";
import shortenText from "../../utils/shortenText";

const Sms = () => {

    const dispatch = useDispatch()
    const isLoaded = useRef(false)
    const { user = {} } = useSelector((state) => state.auth)

    const initialState = {
        withdrawal: false,
        success: false,
        payload: {
            numbers: []
        },
        isActive: 1,
        data: [],
        page: 'inbox',
        loading: false,
        sentMessages: [],
        customers: [],
        selectedMessage: {},
    }

    const [state, setState] = useState(initialState)

    const phone_numbers = state.customers.map((customer) => {
        return {label: `${customer.full_name} - ${customer.mobile}`, value: customer.mobile}
    })

    useEffect(() => {
        if(!isLoaded.current) {
            loadSmsData()
            loadCustomers()
            isLoaded.current = true
        }
    }, [])

    const loadSmsData = () => {
        const action = user?.user_type === 'owner' ? getSmsList() : managerGetSmsList()
        dispatch(action)
        .then((response) => {
            if(response?.payload?.results) {
                let results = response.payload.results
                setState((prevState) => ({...prevState, data: results }))
            }
        })
    }

    const handleInput = (event) => {
        const { name, value } = event.target
        setState((prevState)=> ({...prevState, payload:{...prevState.payload, [name]: value}}))
    }

    const sendMessage = () => {
        setState((prevState) => ({...prevState, loading: true }))
        const action = user?.user_type === 'owner' ? sendSms(state.payload) : managerSendSms(state.payload)
       dispatch(action)
       .then((response) => {
           if(response.payload?.success && response.payload?.success === true) {
               loadSmsData()
                Swal.fire({
                    icon: 'success',
                    text: response.payload?.message || 'Message sent'
                })
                setState((prevState) => ({ ...prevState, withdrawal: false }))
            }
            else {
               Swal.fire({
                   icon: 'error',
                   text: response.payload?.message || 'Could not send message'
               })
           }
       })
       .finally(() => setState((prevState) => ({...prevState, loading: false})))
    }

    const confirmDelete = (id) => {
        setState((prevState) => ({...prevState, loading: true }))
        const action = user?.user_type === 'owner' ? deleteSmsById(id) : managerDeleteCustomerById(id)
       dispatch(action)
       .then((res) => {
            if(res.payload?.success && res.payload?.success === true) {
                loadSmsData()
                Swal.fire({
                    icon: 'success',
                    text: res.payload?.message || 'Message deleted'
                })
            }
            else {
                Swal.fire({
                    icon: 'error',
                    text: res.payload?.message || 'Could not delete message'
                })
            }
        })
       .finally(() => setState((prevState) => ({...prevState, loading: false })))
    }

    const handleDelete = (message_id) => {
        Swal.fire({
            icon: 'warning',
            text: 'Are you sure you want to delete this?',
            showConfirmButton: true,
            confirmButtonText: "Yes, Proceed",
            showCancelButton: true,
          }).then((result) => {
              if (result.isConfirmed){
                confirmDelete(message_id);
              }
          });
    }

    const loadCustomers = () => {
        const action = user?.user_type === 'owner' ? getCustomersList() : managerGetCustomersList()
        dispatch(action)
        .then((response) => {
            if(response.payload?.results) {
                setState((prevState) => ({...prevState, customers: response.payload.results }))
            }
            else {
                Swal.fire({
                    icon: "error",
                    text: response.payload?.message || 'An error occured'
                })
            }
        })
    }

    const handleSelect = (event) => {
        let contacts = event.map((contact) => {
            return contact.value
        })
        setState((prevState) => ({...prevState, payload: {...prevState.payload, numbers: contacts} }))
    }

    return (
        <Layout>
            <>
                <Row>
                    <Col md={3} className="bg-white full-height">
                        <Container className="p-4 py-5">
                            <h3>My Messages</h3>
                            <div className="mt-3 mb-3">
                                <Button 
                                    type="button" 
                                    variant="primary" 
                                    className="mb-5"
                                    onClick={ () => setState((prevState) => ({...prevState, withdrawal: true })) }
                                >
                                    <FontAwesomeIcon icon={'edit'} style={{fontSize: "20px"}} />
                                    <span className="px-2">Compose Message</span>
                                </Button>
                                <nav className="email-listing">
                                    <div className="nav-item d-flex align-items-center font-bold gap-3 mb-2 mt-3">
                                        <Image src={envelope} alt="inbox" /> Inbox
                                    </div>
                                    <ul className="p-0">
                                        {
                                            state.data?.length ? (
                                                state.data?.map((item, index) => (
                                                    <li key={item.id} className="font-bold text-primary">
                                                       <button 
                                                            type="button" 
                                                            className={state.selectedMessage?.id === item.id ? 'selected btn-plain' : `btn-plain`}
                                                            onClick={() => setState((prevState) => ({...prevState, selectedMessage: item}))}
                                                        >
                                                            {shortenText(item.message, 30)}
                                                        </button> 
                                                    </li>
                                                ))
                                            ) : null
                                        }
                                    </ul>
                                </nav>
                            </div>
                        </Container>
                    </Col>
                    <Col md={9}>
                        <Container fluid className="mt-5">
                            <Collapse in={state.page === 'inbox'}>
                                <div>
                                    <div className="d-flex gap-2">
                                        <Button 
                                            type="button" 
                                            variant="light" 
                                            className={state.isActive === 1 ? "bg-white text-primary border-0" : "text-muted border-0"}
                                            onClick={ () => setState((prevState) => ({...prevState, isActive: 1 })) }
                                        >
                                            Broadcast mails
                                        </Button>
                                        <Button 
                                            type="button" 
                                            variant="light" 
                                            className={state.isActive === 2 ? "bg-white text-primary border-0" : "text-muted border-0"}
                                            onClick={ () => setState((prevState) => ({...prevState, isActive: 2 })) }
                                        >
                                            Personalized mails
                                        </Button>
                                    </div>
                                    <Card className="border-0 bg-transparent">
                                        <Card.Body className="p-4m mailing-list bg-transparent table-responsive-lg">
                                            {
                                                    state.selectedMessage && (
                                                        <div>
                                                            <div className="d-flex m-0 align-items-center justify-content-end gap-2">
                                                                {dateFormatter(state.selectedMessage.date)} 
                                                                <button 
                                                                    type="button"
                                                                    className="btn-plain"
                                                                    onClick={ () => handleDelete(state.selectedMessage.id) }
                                                                >
                                                                    <FontAwesomeIcon icon={'trash'} className="text-danger" style={{fontSize: "18px"}} />
                                                                </button>
                                                            </div>
                                                            <p className="mt-3">
                                                                {state.selectedMessage.message}
                                                            </p>
                                                        </div>
                                                    )
                                                }
                                        </Card.Body>
                                    </Card>
                                </div>
                            </Collapse>
                            <Collapse in={state.page === 'sent'}>
                                <Card className="border-0 bg-transparent">
                                    <Card.Body className="mailing-list bg-transparent table-responsive-lg">
                                        <h5>Sent Messages</h5>
                                        <Table size="sm" className="table-color">
                                            <tbody>
                                                {
                                                    state.sentMessages?.length ? (
                                                        state.sentMessages?.map((item, index) => (
                                                            <tr key={index} className="border-bottom">
                                                                <td className="bg-transparent">
                                                                    <div className="m-0 d-flex gap-2 align-items-center">
                                                                        <FormCheck type="checkbox"/>
                                                                        <img src={item.avatar || 'https://placehold.co/50'} alt={item.message} width="45" className="rounded-circle"/>
                                                                        <strong>
                                                                            {item.name}
                                                                        </strong>
                                                                    </div>
                                                                </td>
                                                                <td className="bg-transparent">
                                                                    <span>{item.title}</span> - <strong>{item.message}</strong>
                                                                </td>
                                                                <td className="bg-transparent">
                                                                    <div className="d-flex m-0 align-items-center justify-content-between">
                                                                        {item.date}
                                                                        <Dropdown>
                                                                            <Dropdown.Toggle variant="light" className="border-0 bg-transparent" size="sm" id="dropdown-basic">
                                                                                <FontAwesomeIcon icon="ellipsis-vertical" style={{fontSize: "20px"}} className="text-muted"/>
                                                                            </Dropdown.Toggle>
    
                                                                            <Dropdown.Menu className="border-0 shadow px-3 py-4">
                                                                                <Dropdown.Item 
                                                                                    eventKey={2} 
                                                                                    className="d-flex align-items-center gap-1 text-danger"
                                                                                    onClick={ () => handleDelete(item.id) }
                                                                                >
                                                                                    <FontAwesomeIcon icon="trash" /> Delete
                                                                                </Dropdown.Item>
                                                                            </Dropdown.Menu>
                                                                        </Dropdown>
                                                                    </div>
                                                                </td>
                                                            </tr>
                                                        ))
                                                    ) 
                                                    : 
                                                    (
                                                        <tr>
                                                            <td colSpan={5} className="text-center text-muted">No data found</td>
                                                        </tr>
                                                    )
                                                }
                                            </tbody>
                                        </Table>
                                    </Card.Body>
                                </Card>
                            </Collapse>
                        </Container>
                    </Col>
                </Row>

                <Modal
                    show={state.withdrawal}
                    onHide={() => setState((prevState) => ({...prevState, withdrawal: false }))}
                    size="md"
                    backdrop="static"
                    title="New Sms"
                >
                    <Modal.Header className="bg-primary text-white" closeButton>
                        <Modal.Title as={"h5"}>New SMS</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <Form>
                            <Row>
                                <Form.Group as={Col} md={12} className="mb-3">
                                    <Form.Label>Type</Form.Label>
                                    <Form.Select
                                        required
                                        name="type"
                                        className="form-control"
                                        onChange={handleInput}
                                    >
                                        <option value="">---Select---</option>
                                        <option value="personalized">Personalized</option>
                                        <option value="broadcast">Broadcast</option>
                                    </Form.Select>
                                </Form.Group>
                                <Form.Group as={Col} md={12} className="mb-3">
                                    <Form.Label className="mb-0">Select Customers</Form.Label>
                                    <Select 
                                        name="numbers" 
                                        options={phone_numbers}
                                        onChange={ handleSelect }
                                        isMulti
                                        closeMenuOnSelect={false}
                                        styles={{
                                            control: (baseStyles, state) => ({
                                                ...baseStyles,
                                                height: "35px",
                                                paddingLeft: "0px"
                                            }), 
                                        }}
                                    />
                                </Form.Group>
                                <Form.Group as={Col} md={12} className="mb-3">
                                    <Form.Label>Message</Form.Label>
                                    <textarea
                                        required
                                        rows={4}
                                        placeholder="Message"
                                        name="message"
                                        className="form-control"
                                        onChange={handleInput}
                                    ></textarea>
                                </Form.Group>
                                <Form.Group as={Col} md={12} className="mb-3">
                                    <Button 
                                        type="button" 
                                        variant="primary" 
                                        className="form-control"
                                        onClick={ sendMessage }
                                    >
                                        Send Message <Spinner animation={ state.loading ? "border" : null} role="status" size="sm"></Spinner>
                                    </Button>
                                </Form.Group>
                            </Row>
                        </Form>
                    </Modal.Body>
                </Modal>

                <AlertModal
                    title="Successful!"
                    text="Message sent"
                    buttonText="Ok"
                    onHide={() => setState((prevState) => ({...prevState, success: false }))}
                    onClick={() => setState((prevState) => ({...prevState, success: false }))}
                    show={state.success}
                >
                    <svg xmlns="http://www.w3.org/2000/svg" width="64" height="64" viewBox="0 0 64 64" fill="none">
                    <path d="M32 4C26.4621 4 21.0486 5.64217 16.444 8.71885C11.8395 11.7955 8.25064 16.1685 6.13139 21.2849C4.01213 26.4012 3.45764 32.0311 4.53802 37.4625C5.61841 42.894 8.28515 47.8831 12.201 51.799C16.1169 55.7149 21.106 58.3816 26.5375 59.462C31.969 60.5424 37.5988 59.9879 42.7151 57.8686C47.8315 55.7494 52.2045 52.1605 55.2812 47.556C58.3578 42.9514 60 37.5379 60 32C60 24.5739 57.05 17.452 51.799 12.201C46.548 6.94999 39.4261 4 32 4ZM47.42 23.42L27.42 43.42C27.2341 43.6075 27.0129 43.7562 26.7692 43.8578C26.5254 43.9593 26.264 44.0116 26 44.0116C25.736 44.0116 25.4746 43.9593 25.2309 43.8578C24.9871 43.7562 24.7659 43.6075 24.58 43.42L14.58 33.42C14.3935 33.2335 14.2456 33.0121 14.1447 32.7685C14.0438 32.5249 13.9918 32.2637 13.9918 32C13.9918 31.4674 14.2034 30.9566 14.58 30.58C14.9566 30.2034 15.4674 29.9918 16 29.9918C16.5326 29.9918 17.0434 30.2034 17.42 30.58L26 39.18L44.58 20.58C44.9566 20.2034 45.4674 19.9918 46 19.9918C46.5326 19.9918 47.0434 20.2034 47.42 20.58C47.7966 20.9566 48.0082 21.4674 48.0082 22C48.0082 22.5326 47.7966 23.0434 47.42 23.42Z" fill="#B2B1FF"/>
                    </svg>
                    
                </AlertModal>
            </>
        </Layout>
    );
}

export default Sms;